import zoom from "./zoom.js";

const install = function(Vue) {
  Vue.directive("zoom", zoom);
};
// tslint:disable-next-line
zoom["install"] = install;
export default zoom;
